import { createActions } from 'redux-actions';

export const actions = createActions({
  TODO: {
    LOAD: () => {},
  },
}).todo;
